import { _request, _requestForm } from './api';

export const exportContracts = async (filters = {}) => {
  const params = new URLSearchParams();
  ['t_id', 't_club_entities_id', 't_player_entities_id', 't_date', 't_status_id'].forEach(key => {
    const value = filters[key];
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, value);
    }
  });

  const token = localStorage.getItem('token');
  const response = await fetch(
    `${process.env.REACT_APP_BASE_API_URL}/contract/export?${params.toString()}`,
    {
      method: 'GET',
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    }
  );

  if (!response.ok) {
    let message = 'Greška pri izvozu ugovora u Excel.';
    try {
      const errorBody = await response.json();
      message = errorBody.message || message;
    } catch (_) {
      // Keep the fallback message when the error response is not JSON.
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  try {
    link.href = url;
    link.download = 'contracts.xlsx';
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    window.URL.revokeObjectURL(url);
  }
};

export const add = data => {
  const params = data;
  return new Promise((resolve, reject) => {
    return _requestForm({
      target: 'contract',
      method: 'POST',
      params
    })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const edit = (data, documentGuid) => {
  const params = data;
  return new Promise((resolve, reject) => {
    return _requestForm({
      target: `contract/${documentGuid}`,
      method: 'PUT',
      params
    })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const remove = documentGuid => {
  return new Promise((resolve, reject) => {
    return _request({
      target: `contract/${documentGuid}`,
      method: 'DELETE'
    })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const item = documentGuid => {
  return new Promise((resolve, reject) => {
    return _request({
      target: `contract/${documentGuid}`,
      method: 'GET'
    })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const list = data => {
  const params = data;
  return new Promise((resolve, reject) => {
    return _request({
      target: 'contract',
      method: 'GET',
      params
    })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const latestByPlayer = playersEntitiesId => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'contract/latest-by-player',
      method: 'GET',
      params: { players_entities_id: playersEntitiesId }
    })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const listContractDurations = () => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'contract/contract-durations',
      method: 'GET'
    })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const listPlayers = (data) => {
  let params = data;
  return new Promise((resolve, reject) => {
    return _request({
      target: 'contract/players', method: 'GET', params
    })
        .then((response) => {
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
  })
};

export const listContractTerminations = () => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'contract/contract-terminations',
      method: 'GET'
    })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const processContract = (documentGuid, data) => {
  const params = data;
  return new Promise((resolve, reject) => {
    return _request({
      target: `contract/process-document/${documentGuid}`,
      method: 'PUT',
      params
    })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const cancelContract = (documentGuid, data) => {
  const params = data;
  return new Promise((resolve, reject) => {
    return _request({
      target: `contract/cancel/${documentGuid}`,
      method: 'PUT',
      params
    })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const printContract = async (documentGuid, printWindow) => {
  const token = localStorage.getItem('token');
  const response = await fetch(
    `${process.env.REACT_APP_BASE_API_URL}/contract/print/${documentGuid}`,
    {
      method: 'GET',
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    }
  );

  if (!response.ok) {
    let message = `HTTP error! status: ${response.status}`;

    try {
      const errorBody = await response.json();
      message = errorBody.message || message;
    } catch (_) {
      // Response is not JSON.
    }

    throw new Error(message);
  }

  const blob = await response.blob();
  const documentUrl = URL.createObjectURL(blob);
  const targetWindow = printWindow || window.open('', '_blank');

  if (!targetWindow) {
    URL.revokeObjectURL(documentUrl);
    throw new Error('Preglednik je blokirao prozor za stampu.');
  }

  targetWindow.onload = () => {
    targetWindow.focus();
    targetWindow.print();
    window.setTimeout(() => URL.revokeObjectURL(documentUrl), 1000);
  };
  targetWindow.location.href = documentUrl;
};
